// extracted by mini-css-extract-plugin
export default {"content":"Layout_content__HZmkn","contentBox":"Layout_contentBox__uFTzl","layout":"Layout_layout__2sspH","footer":"Layout_footer__j2S+q","header":"Layout_header__Py9jm"};